// Sistema de traducciones para Taskit

export const translations = {
  es: {
    // Home Page
    appName: 'Taskit',
    heroSubtitle: 'Crea y comparte listas de tareas',
    heroDescription: 'Taskit es la forma más simple de compartir una lista. Escribe tus tareas, genera un enlace al instante y envíalo. Sin registros, sin complicaciones.',
    
    // Form
    titleLabel: 'Título de la lista (opcional)',
    titlePlaceholder: 'Ej: Lista de Compras, Tareas del Proyecto...',
    tasksLabel: 'Tareas (una por línea) *',
    tasksPlaceholder: 'Escribe cada tarea en una nueva línea\n\nEj:\nComprar leche\nLlamar al cliente\nEnviar reporte',
    tasksCount: 'tarea(s)',
    exampleButton: 'Ver ejemplo',
    generateButton: 'Generar enlace',
    generatingButton: 'Generando...',
    
    // Errors
    errorMinTasks: 'Por favor, ingresa al menos una tarea',
    
    // Features
    featureFast: 'Rápido',
    featureFastDesc: 'Crea y comparte en segundos',
    featureUnique: 'Enlaces únicos',
    featureUniqueDesc: 'Cada lista tiene su propia URL',
    featureMulti: 'Multiplataforma',
    featureMultiDesc: 'Funciona en cualquier dispositivo',
    
    // Footer
    footerText: 'Creado con ❤️ por',
    footerBy: 'mikejauregui',
    
    // List View
    backButton: '← Nueva lista',
    progressText: 'de',
    progressCompleted: 'completadas',
    shareButton: 'Compartir lista',
    copiedButton: '✓ Copiado',
    createNewList: 'Crear nueva lista',
    
    // Success Message
    successTitle: '¡Lista completada!',
    successText: 'Has terminado todas las tareas',
    successButton: 'Crear nueva lista',
    
    // Share Text
    shareTitle: 'Taskit',
    shareText: 'Te comparto mi lista',
    
    // Error Page
    errorTitle: 'Oops',
    errorNotFound: 'Lista no encontrada',
    errorLoading: 'Error al cargar la lista',
    errorConnection: 'Error de conexión. Por favor, intenta de nuevo.',
    loadingText: 'Cargando lista...',
    errorAddingTask: 'Error al agregar la tarea',
    
    // Add Task
    addTaskPlaceholder: 'Agregar nueva tarea...',
    addTaskButton: 'Agregar',
    addingTask: 'Agregando...',
    
    // Timer
    timerStart: 'Iniciar',
    timerPause: 'Pausar',
    timerResume: 'Reanudar',
    timerFinish: 'Finalizar',
    timerActive: 'En progreso',
    timerPaused: 'Pausada',
    timerCompleted: 'Completada',
    timerNotStarted: 'No iniciada',
    timerTimeFormat: '{hours}h {minutes}m {seconds}s',
    timerZeroTime: '0s',
    timerErrorActiveTask: 'Ya hay una tarea activa. Pausa o finaliza la tarea actual primero.',
    timerErrorGeneric: 'Error al realizar la acción. Por favor intenta de nuevo.',
    
    // Statistics
    statisticsTitle: 'Estadísticas de tiempo',
    statisticsTotalTime: 'Tiempo total',
    statisticsAvgTime: 'Promedio por tarea',
    statisticsFastestTask: 'Más rápida',
    statisticsSlowestTask: 'Más demorada',
    statisticsShow: 'Mostrar estadísticas',
    statisticsHide: 'Ocultar estadísticas',
    statisticsNoTime: 'Sin tiempo registrado',
    
    // Language
    language: 'Idioma',
    spanish: 'Español',
    english: 'English'
  },
  
  en: {
    // Home Page
    appName: 'Taskit',
    heroSubtitle: 'Create and share task lists',
    heroDescription: 'Taskit is the simplest way to share a list. Just type your tasks, generate an instant link, and send it. No sign-ups, no fuss.',
    
    // Form
    titleLabel: 'List title (optional)',
    titlePlaceholder: 'E.g: Shopping List, Project Tasks...',
    tasksLabel: 'Tasks (one per line) *',
    tasksPlaceholder: 'Write each task on a new line\n\nE.g:\nBuy milk\nCall client\nSend report',
    tasksCount: 'task(s)',
    exampleButton: 'View example',
    generateButton: 'Generate link',
    generatingButton: 'Generating...',
    
    // Errors
    errorMinTasks: 'Please enter at least one task',
    
    // Features
    featureFast: 'Fast',
    featureFastDesc: 'Create and share in seconds',
    featureUnique: 'Unique links',
    featureUniqueDesc: 'Each list has its own URL',
    featureMulti: 'Cross-platform',
    featureMultiDesc: 'Works on any device',
    
    // Footer
    footerText: 'Created with ❤️ by',
    footerBy: 'mikejauregui',
    
    // List View
    backButton: '← New list',
    progressText: 'of',
    progressCompleted: 'completed',
    shareButton: 'Share list',
    copiedButton: '✓ Copied',
    createNewList: 'Create new list',
    
    // Success Message
    successTitle: 'List completed!',
    successText: 'You finished all tasks',
    successButton: 'Create new list',
    
    // Share Text
    shareTitle: 'Taskit',
    shareText: 'Have a look at my list',
    
    // Error Page
    errorTitle: 'Oops',
    errorNotFound: 'List not found',
    errorLoading: 'Error loading list',
    errorConnection: 'Connection error. Please try again.',
    loadingText: 'Loading list...',
    errorAddingTask: 'Error adding task',
    
    // Add Task
    addTaskPlaceholder: 'Add new task...',
    addTaskButton: 'Add',
    addingTask: 'Adding...',
    
    // Timer
    timerStart: 'Start',
    timerPause: 'Pause',
    timerResume: 'Resume',
    timerFinish: 'Finish',
    timerActive: 'In progress',
    timerPaused: 'Paused',
    timerCompleted: 'Completed',
    timerNotStarted: 'Not started',
    timerTimeFormat: '{hours}h {minutes}m {seconds}s',
    timerZeroTime: '0s',
    timerErrorActiveTask: 'There is already an active task. Pause or finish the current task first.',
    timerErrorGeneric: 'Error performing action. Please try again.',
    
    // Statistics
    statisticsTitle: 'Time Statistics',
    statisticsTotalTime: 'Total time',
    statisticsAvgTime: 'Average per task',
    statisticsFastestTask: 'Fastest',
    statisticsSlowestTask: 'Slowest',
    statisticsShow: 'Show statistics',
    statisticsHide: 'Hide statistics',
    statisticsNoTime: 'No time recorded',
    
    // Language
    language: 'Language',
    spanish: 'Español',
    english: 'English'
  }
};

// Detectar idioma del navegador
export const detectBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  
  // Extraer el código de idioma (ej: 'es-MX' -> 'es')
  const langCode = browserLang.split('-')[0].toLowerCase();
  
  // Si el idioma es español, usar español; de lo contrario, inglés
  return langCode === 'es' ? 'es' : 'en';
};

// Obtener idioma guardado o detectar automáticamente
export const getInitialLanguage = () => {
  const savedLang = localStorage.getItem('taskit-language');
  return savedLang || detectBrowserLanguage();
};

// Guardar preferencia de idioma
export const saveLanguage = (lang) => {
  localStorage.setItem('taskit-language', lang);
};

